(function() {
'use strict';

angular
    .module('ekh')
    .directive('productCarousel', productCarousel);

function productCarousel($timeout) {
    function _linker(scope, el, attr) {
        const baseOptions = {
            speed: 1000,
            slidesToShow: parseInt(attr.items) || 4,
            swipeToSlide: true,
            rtl: !!TRPCONFIG.Rtl
        };

        const itemOptions = {
            4: {
                slidesToShow: 4,
                responsive: [{
                    breakpoint: 500,
                    settings: { slidesToShow: 1 }
                }, {
                    breakpoint: 910,
                    settings: { slidesToShow: 2 }
                }, {
                    breakpoint: 1280,
                    settings: { slidesToShow: 3 }
                }]
            },
            9: {
                slidesToShow: 6,
                responsive: [{
                    breakpoint: 480,
                    settings: { slidesToShow: 2 }
                }, {
                    breakpoint: 768,
                    settings: { slidesToShow: 3 }
                }, {
                    breakpoint: 1280,
                    settings: { slidesToShow: 4 }
                }]
            },
            1: {
                autoplay: true,
                autoplaySpeed: parseInt(attr.autoplayTimeout) || 3000,
                slidesToShow: 1
            }
        };

        const carouselOptions = angular.extend(baseOptions, itemOptions[attr.itemOptions]);
        if (attr.staticItems) {
            el.slick(carouselOptions);
        } else {
            $timeout(() => {
                if (scope.tiles != null && scope.tiles.length > 1) {
                    el.slick(carouselOptions);
                }
            });
        }
    }

    return {
        restrict: 'A',
        scope: {
            tiles: '='
        },
        link: _linker
    };
}
})();
